module.exports = __webpack_public_path__ + "img/Alpha_64x64.0380fe25.png";